import { apiCall } from './gqlClient';
const GETRESERVATIONPRICE_QUERY = "\n  query getReservationPrice($subServiceId: Int!) {\n    getReservationPrice(subServiceId: $subServiceId)\n    {\n      price\n\t\t\tdiscount\n\t\t\tpriceWithoutDiscount\n\t\t\tuserHasMembership\n\t\t\twaitingList\n      ...fragments\n    }\n  }";
export const getReservationPriceApiCall = async function (_ref) {
  let {
    subServiceId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETRESERVATIONPRICE_QUERY,
    variables: {
      subServiceId
    },
    fragments
  });
};
const GETCUSTOMERSSUBSERVICERESERVATIONS_QUERY = "\n  query getCustomersSubserviceReservations($subserviceId: Int!, $userId: Int, $customerId: Int) {\n    getCustomersSubserviceReservations(subserviceId: $subserviceId, userId: $userId, customerId: $customerId)\n  }";
export const getCustomersSubserviceReservationsApiCall = async _ref2 => {
  let {
    subserviceId,
    userId,
    customerId
  } = _ref2;
  return apiCall({
    query: GETCUSTOMERSSUBSERVICERESERVATIONS_QUERY,
    variables: {
      subserviceId,
      userId,
      customerId
    }
  });
};
const GETRESERVATIONSFORMULTIPLECANCEL_QUERY = "\n  query getReservationsForMultipleCancel($request: ReservationsForCancelInput!) {\n    getReservationsForMultipleCancel(request: $request)\n  }";
export const getReservationsForMultipleCancelApiCall = async _ref3 => {
  let {
    request
  } = _ref3;
  return apiCall({
    query: GETRESERVATIONSFORMULTIPLECANCEL_QUERY,
    variables: {
      request
    }
  });
};
const CREATERESERVATION_QUERY = "\n  mutation createReservation($request: CreateReservationInput) {\n    createReservation(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createReservationApiCall = async function (_ref4) {
  let {
    request
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATERESERVATION_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATEMULTIPLERESERVATION_QUERY = "\n  mutation createMultipleReservation($request: CreateMultipleReservationInput!) {\n    createMultipleReservation(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createMultipleReservationApiCall = async function (_ref5) {
  let {
    request
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEMULTIPLERESERVATION_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATERESERVATIONASANONYMOUS_QUERY = "\n  mutation createReservationAsAnonymous($subServiceId: Int!, $resourceId: Int!, $dateTimeFrom: DateTime!, $email: String!, $onlyBook: Boolean, $firstname: String, $lastname: String, $phone: String) {\n    createReservationAsAnonymous(subServiceId: $subServiceId, resourceId: $resourceId, dateTimeFrom: $dateTimeFrom, email: $email, onlyBook: $onlyBook, firstname: $firstname, lastname: $lastname, phone: $phone)\n    {\n      id\n\t\t\tmessage\n\t\t\tsuccess\n\t\t\tamount\n\t\t\tamountCents\n\t\t\tclientSecret\n\t\t\tstripeAccount\n\t\t\tofferId\n\t\t\tproductId\n      ...fragments\n    }\n  }";
export const createReservationAsAnonymousApiCall = async function (_ref6) {
  let {
    subServiceId,
    resourceId,
    dateTimeFrom,
    email,
    onlyBook,
    firstname,
    lastname,
    phone
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATERESERVATIONASANONYMOUS_QUERY,
    variables: {
      subServiceId,
      resourceId,
      dateTimeFrom,
      email,
      onlyBook,
      firstname,
      lastname,
      phone
    },
    fragments
  });
};
const CONFIRMRESERVATION_QUERY = "\n  mutation confirmReservation($code: JSON!) {\n    confirmReservation(code: $code)\n  }";
export const confirmReservationApiCall = async _ref7 => {
  let {
    code
  } = _ref7;
  return apiCall({
    query: CONFIRMRESERVATION_QUERY,
    variables: {
      code
    }
  });
};
const UPDATERESERVATION_QUERY = "\n  mutation updateReservation($request: ReservationUpdateInput!) {\n    updateReservation(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const updateReservationApiCall = async function (_ref8) {
  let {
    request
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATERESERVATION_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const ACTIVATERESERVATION_QUERY = "\n  mutation activateReservation($reservationId: Int!) {\n    activateReservation(reservationId: $reservationId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const activateReservationApiCall = async function (_ref9) {
  let {
    reservationId
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ACTIVATERESERVATION_QUERY,
    variables: {
      reservationId
    },
    fragments
  });
};
const CANCELRESERVATION_QUERY = "\n  mutation cancelReservation($reservationId: Int!) {\n    cancelReservation(reservationId: $reservationId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const cancelReservationApiCall = async function (_ref10) {
  let {
    reservationId
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CANCELRESERVATION_QUERY,
    variables: {
      reservationId
    },
    fragments
  });
};
const CHANGEUSERRESERVATIONSNUMBER_QUERY = "\n  mutation changeUserReservationsNumber($id: Int!, $numberOfReservations: Int!, $action: Boolean!, $startTime: DateTime, $endTime: DateTime) {\n    changeUserReservationsNumber(id: $id, numberOfReservations: $numberOfReservations, action: $action, startTime: $startTime, endTime: $endTime)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const changeUserReservationsNumberApiCall = async function (_ref11) {
  let {
    id,
    numberOfReservations,
    action,
    startTime,
    endTime
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERRESERVATIONSNUMBER_QUERY,
    variables: {
      id,
      numberOfReservations,
      action,
      startTime,
      endTime
    },
    fragments
  });
};
const CHANGEUSERRESERVATIONPRESENCE_QUERY = "\n  mutation changeUserReservationPresence($reservationId: Int!, $presence: String!) {\n    changeUserReservationPresence(reservationId: $reservationId, presence: $presence)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const changeUserReservationPresenceApiCall = async function (_ref12) {
  let {
    reservationId,
    presence
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERRESERVATIONPRESENCE_QUERY,
    variables: {
      reservationId,
      presence
    },
    fragments
  });
};
const CANCELMULTIPLERESERVATIONSBYIDS_QUERY = "\n  mutation cancelMultipleReservationsByIds($reservationIds: [Int]!) {\n    cancelMultipleReservationsByIds(reservationIds: $reservationIds)\n  }";
export const cancelMultipleReservationsByIdsApiCall = async _ref13 => {
  let {
    reservationIds
  } = _ref13;
  return apiCall({
    query: CANCELMULTIPLERESERVATIONSBYIDS_QUERY,
    variables: {
      reservationIds
    }
  });
};